import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, Optional } from '@angular/core';
import { ExterneAppFeatureService } from '../../../municipality-management/services/externe-app-feature.service';
import { environment } from '../../../../environments/environment';
import { GenericAppFormIconProps } from '../../models/generic-app';
import { BehaviorSubject, first, from, Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-features-icon-app',
  templateUrl: './features-icon-app.component.html',
  styleUrls: ['./features-icon-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesIconAppComponent implements OnChanges {
  @Input() icon!: string;
  @Input() hoverIcon!: string;
  @Input() disabled = false;
  @Input() dashboard = false;
  @Input() isTeaser = false;
  @Input() canCreateTeaser = false;

  public iconFile: BehaviorSubject<string | GenericAppFormIconProps> = new BehaviorSubject<string | GenericAppFormIconProps>('');
  public hoverIconFile: BehaviorSubject<string | GenericAppFormIconProps> = new BehaviorSubject<string | GenericAppFormIconProps>('');

  constructor(@Optional() private externeAppFeatureService: ExterneAppFeatureService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['icon']) {
      let iconFile = this.icon.includes(';') ? this.icon.split(';')?.[0] : this.icon;

      from([iconFile])
        .pipe(
          first(),
          switchMap((_iconFile) => this.getIconDetails(_iconFile))
        )
        .subscribe((_icon) => {
          this.iconFile.next(_icon);
        });
    }

    if (changes['hoverIcon']) {
      let hoverIconFile = this.hoverIcon.includes(';') ? this.hoverIcon.split(';')?.[0] : this.hoverIcon;

      if (hoverIconFile.length > 0) {
        from([hoverIconFile])
          .pipe(
            first(),
            switchMap((_hoverIconFile) => this.getIconDetails(_hoverIconFile))
          )
          .subscribe((_hoverIcon) => {
            this.hoverIconFile.next(_hoverIcon);
          });
      }
    }
  }

  private getIconDetails(iconFile: string): Observable<string | GenericAppFormIconProps> {
    const isPreset: boolean = iconFile.includes('preset') ? true : false;
    const isImg = iconFile.includes('.png') || iconFile.includes('.jpg') || iconFile.includes('.jpeg');
    iconFile = iconFile.includes('_') ? iconFile.split('_').slice(1).join('_') : iconFile;
    if (!isImg && this.externeAppFeatureService) {
      return this.externeAppFeatureService.getSVGCode(iconFile, isPreset);
    } else {
      return of(`${environment.proxyApiURL}/api/icon/${isPreset ? 'preset' : 'upload'}/${iconFile}`);
    }
  }
}
